import React, {useEffect, useState} from 'react'
import {Pagination} from '../../../../components/Pagination'
import './tableAcessos.css'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../../reducers'
import {gu_cu_SetSucursalesSeleccionadas} from '../../../../actions/gestion-usuario/creacion-usuario/creacionUsuario.actions'
import { convertStringToNit } from '../../../../utils/strings.utils'

const TablaAccesos = () => {
  const sucursales = useSelector(
    (state: State) => state.gestionUsuario.creacionUsuario.catalogos.sucursales
  )
  const [currentItems, setCurrentItems] = useState<Array<any>>([])
  const [selectAll, setSelectAll] = useState<boolean>(false)
  const [selectedRows, setSelectedRows] = useState<string[]>([])
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(gu_cu_SetSucursalesSeleccionadas(selectedRows))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRows])

  const handleCheckboxChange = (event: any, rowId: string) => {
    // Agrega el id de la fila seleccionada
    if (event.target.checked) setSelectedRows([...selectedRows, rowId])
    // Remueve el id de la fila deseleccionada
    else setSelectedRows(selectedRows.filter((id) => id !== rowId))
  }

  const handleSelectAll = () => {
    const newSelectAll = !selectAll
    setSelectAll(newSelectAll)
    // Si "Seleccionar todos" esta marcado
    if (newSelectAll) setSelectedRows([...sucursales.filter((sucu => sucu?.activo === "true")).map((sucursal: any) => sucursal?.idsucursal)])
    // Si "Seleccionar todos" está desmarcado
    else setSelectedRows([])
  }

  return (
    <div className='tab-plane mt-16'>
      <table className='ta-cu-table-main-responsive ta-cu-responsive-table-main td-left table-pointer'>
        <thead>
          <tr>
            <td>
              <label className='w-checkbox' style={{marginLeft: '3%'}}>
                <input autoComplete='off'
                  type='checkbox'
                  checked={sucursales.length > 0 && selectedRows.length === sucursales.length}
                  onChange={handleSelectAll}
                />
                <div className='checkbox__checkmark'></div>
                <div className='checkbox__body' style={{fontWeight: '400'}}>
                  No. Sucursal
                </div>
              </label>
            </td>
            <td>Nombre</td>
            <td>Dirección</td>
            <td>NIT</td>
          </tr>
        </thead>
        <tbody>
          {
            currentItems.length === 0 && (
              <tr>
                <td colSpan={4} style={{textAlign: 'center', padding: '20px 0px'}}>No hay sucursales activas para asignar al usuario</td>
              </tr>
            )
          }
          {currentItems.map((element, index) => (
            <tr key={index}>
              <td data-label='No. Sucursal' onClick={(e) => e.stopPropagation()}>
                <label className='w-checkbox' style={{marginLeft: '3%'}}>
                  <input autoComplete='off'
                    type='checkbox'
                    checked={selectedRows.includes(element?.idsucursal)}
                    onChange={(e) => {
                      handleCheckboxChange(e, element?.idsucursal)
                    }}
                  />
                  <div className='checkbox__checkmark'></div>
                  <div className='checkbox__body fw-400'>{index + 1}</div>
                </label>
              </td>
              <td data-label='Nombre'>{element.nombre}</td>
              <td data-label='Dirección'>{element.direccion}</td>
              <td data-label='NIT'>{convertStringToNit(String(element.nit))}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <Pagination
        data={sucursales.filter((sucu) => sucu.activo == "true" && sucu.eliminado == "0")}
        state={(items: Array<any>) => setCurrentItems(items)}
        items={15}
      />
    </div>
  )
}

export default TablaAccesos
